import Container from 'components/Container'
import { PageSEO } from 'components/SEO'
import { allPosts } from 'contentlayer/generated'
import siteMetadata from 'data/siteMetadata'
import ListLayout from 'layouts/ListLayout'
import { allCoreContent, sortedPublishedPosts } from 'lib/contentlayer'
import { InferGetStaticPropsType } from 'next'

export const getStaticProps = async () => {
  const posts = sortedPublishedPosts(allPosts)

  return {
    props: { posts: allCoreContent(posts) },
  }
}

export default function Blog({ posts }: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <Container>
      <PageSEO
        title={`Blogs - ${siteMetadata.title}`}
        description={`I have been writing since 2020, mostly around tech and my career. In total I have written ${posts.length} posts. I hope you enjoy them.`}
      />
      <ListLayout
        posts={posts}
        title="All Posts"
        description={`I have been writing since 2020, mostly around tech and my career. In total I have written ${posts.length} posts. I hope you enjoy them.`}
      />
    </Container>
  )
}
